import React from 'react';

interface LabelTextTWProps {
  name?: string;
  labelText?: string;
  isError?: boolean;
  isRequired?: boolean;
}

export const LabelTextTW: React.FC<LabelTextTWProps> = ({ labelText, isError, isRequired, name }) => {
  if (labelText === undefined) {
    return null;
  }

  const utilityClassName = `block text-xs whitespace-pre-line ${
    isError ? 'text-text-error' : 'text-text-default-content'
  }`;
  const text = `${labelText}${isRequired ? ' *' : ''}`;

  return (
    <label htmlFor={name} className={utilityClassName}>
      {text}
    </label>
  );
};
